var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-footer',[_c('p',{staticClass:"copyright"},[_vm._v(" Copyright © 2023 Ozone - "+_vm._s(_vm.environment)+" by "),_c('a',{attrs:{"href":"https://creative-tim.com"}},[_vm._v("Agencia People")]),_vm._v(". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }